export const countries = [
    { code: 'af', continent: 'Asia', name: 'Afganistán' },
    { code: 'al', continent: 'Europe', name: 'Albania', nationality: 'Albania' },
    { code: 'dz', continent: 'Africa', name: 'Argelia', nationality: 'Algeria' },
    { code: 'as', continent: 'Oceania', name: 'Samoa Americana​' },
    { code: 'ad', continent: 'Europe', name: 'Andorra', nationality: 'Andorra' },
    { code: 'ao', continent: 'Africa', name: 'Angola' },
    { code: 'ai', continent: 'North America', name: 'Anguilla' },
    { code: 'aq', name: 'Antárctica' },
    { code: 'ag', continent: 'North America', name: 'Antigua y Barbuda' },
    { code: 'ar', continent: 'South America', name: 'Argentina', nationality: 'Argentina' },
    { code: 'am', continent: 'Asia', name: 'Armenia' },
    { code: 'aw', continent: 'South America', name: 'Aruba' },
    { code: 'sh-ac', continent: 'Africa', name: 'Ascension Island' },
    { code: 'au', continent: 'Oceania', name: 'Australia', nationality: 'Australia' },
    { code: 'at', continent: 'Europe', name: 'Austria', nationality: 'Austria' },
    { code: 'az', continent: 'Asia', name: 'Azerbaijan' },
    { code: 'bs', continent: 'North America', name: 'Bahamas' },
    { code: 'bh', continent: 'Asia', name: 'Bahrain' },
    { code: 'bd', continent: 'Asia', name: 'Bangladesh' },
    { code: 'bb', continent: 'North America', name: 'Barbados' },
    { code: 'by', continent: 'Europe', name: 'Bielorrusia' },
    { code: 'be', continent: 'Europe', name: 'Bélgica', nationality: 'Belgium' },
    { code: 'bz', continent: 'North America', name: 'Belice' },
    { code: 'bj', continent: 'Africa', name: 'Benin' },
    { code: 'bm', continent: 'North America', name: 'Bermuda' },
    { code: 'bt', continent: 'Asia', name: 'Bhutan' },
    { code: 'bo', continent: 'South America', name: 'Bolivia' },
    { code: 'bq', continent: 'South America', name: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'ba', continent: 'Europe', name: 'Bosnia y Herzegovina' },
    { code: 'bw', continent: 'Africa', name: 'Botswana' },
    { code: 'br', continent: 'South America', name: 'Brasil', nationality: 'Brazil' },
    { code: 'io', continent: 'Asia', name: 'British Indian Ocean Territory' },
    { code: 'bn', continent: 'Asia', name: 'Brunei Darussalam' },
    { code: 'bg', continent: 'Europe', name: 'Bulgaria' },
    { code: 'bf', continent: 'Africa', name: 'Burkina Faso', nationality: 'Burkina Faso' },
    { code: 'bi', continent: 'Africa', name: 'Burundi' },
    { code: 'cv', continent: 'Africa', name: 'Cabo Verde', nationality: 'Cape Verde' },
    { code: 'kh', continent: 'Asia', name: 'Cambodia' },
    { code: 'cm', continent: 'Africa', name: 'Cameroon', nationality: 'Cameroon' },
    { code: 'ca', continent: 'North America', name: 'Canada', nationality: 'Canada' },
    { code: 'ic', name: 'Canary Islands' },
    { code: 'ky', continent: 'North America', name: 'Cayman Islands' },
    { code: 'cf', continent: 'Africa', name: 'Central African Republic' },
    { code: 'td', continent: 'Africa', name: 'Chad' },
    { code: 'cl', continent: 'South America', name: 'Chile', nationality: 'Chile' },
    { code: 'cn', continent: 'Asia', name: 'China' },
    { code: 'cx', continent: 'Asia', name: 'Christmas Island' },
    { code: 'cc', continent: 'Asia', name: 'Cocos (Keeling) Islands' },
    { code: 'co', continent: 'South America', name: 'Colombia', nationality: 'Colombia' },
    { code: 'km', continent: 'Africa', name: 'Comoros' },
    { code: 'ck', continent: 'Oceania', name: 'Cook Islands' },
    { code: 'cr', continent: 'North America', name: 'Costa Rica' },
    { code: 'hr', continent: 'Europe', name: 'Croacia', nationality: 'Croatia' },
    { code: 'cu', continent: 'North America', name: 'Cuba' },
    { code: 'cw', continent: 'South America', name: 'Curazao' },
    { code: 'cy', continent: 'Europe', name: 'Chipre', nationality: 'Cyprus' },
    { code: 'cz', continent: 'Europe', name: 'República Checa', nationality: 'Czechia' },
    { code: 'ci', continent: 'Africa', name: 'Costa de Marfil', nationality: 'Côte dIvoire' },
    { code: 'cd', continent: 'Africa', name: 'República Democrática del Congo', nationality: 'Congo DR' },
    { code: 'dk', continent: 'Europe', name: 'Dinamarca', nationality: 'Denmark' },
    { code: 'dj', continent: 'Africa', name: 'Djibouti' },
    { code: 'dm', continent: 'North America', name: 'Dominica' },
    {
        code: 'do',
        continent: 'North America',
        name: 'República Dominicana',
        nationality: 'Dominican Republic',
    },
    { code: 'eac', name: 'East African Community' },
    { code: 'ec', continent: 'South America', name: 'Ecuador', nationality: 'Ecuador' },
    { code: 'eg', continent: 'Africa', name: 'Egipto', nationality: 'Egypt' },
    { code: 'sv', continent: 'North America', name: 'El Salvador' },
    { code: 'gb-eng', continent: 'Europe', name: 'Inglaterra', nationality: 'England' },
    { code: 'gq', continent: 'Africa', name: 'Guinea Ecuatorial', nationality: 'Equatorial Guinea' },
    { code: 'er', continent: 'Africa', name: 'Eritrea' },
    { code: 'ee', continent: 'Europe', name: 'Estonia', nationality: 'Estonia' },
    { code: 'sz', continent: 'Africa', name: 'Eswatini' },
    { code: 'et', continent: 'Africa', name: 'Etiopía' },
    { code: 'eu', name: 'Europe' },
    { code: 'fk', continent: 'South America', name: 'Falkland Islands' },
    { code: 'fo', continent: 'Europe', name: 'Islas Feroe' },
    { code: 'fm', continent: 'Oceania', name: 'Estados Federados de Micronesia' },
    { code: 'fj', continent: 'Oceania', name: 'Fiji' },
    { code: 'fi', continent: 'Europe', name: 'Finlandia', nationality: 'Finland' },
    { code: 'fr', continent: 'Europe', name: 'Francia', nationality: 'France' },
    { code: 'gf', continent: 'South America', name: 'Guyana Francesa' },
    { code: 'pf', continent: 'Oceania', name: 'French Polynesia' },
    { code: 'ga', continent: 'Africa', name: 'Gabón' },
    { code: 'gm', continent: 'Africa', name: 'Gambia' },
    { code: 'ge', continent: 'Asia', name: 'Georgia', nationality: 'Georgia' },
    { code: 'de', continent: 'Europe', name: 'Alemania', nationality: 'Germany' },
    { code: 'gh', continent: 'Africa', name: 'Ghana', nationality: 'Ghana' },
    { code: 'gi', continent: 'Europe', name: 'Gibraltar' },
    { code: 'gr', continent: 'Europe', name: 'Grecia', nationality: 'Greece' },
    { code: 'gl', continent: 'North America', name: 'Groenlandia' },
    { code: 'gd', continent: 'North America', name: 'Granada' },
    { code: 'gp', continent: 'North America', name: 'Guadalupe', nationality: 'Guadeloupe' },
    { code: 'gu', continent: 'Oceania', name: 'Guam' },
    { code: 'gt', continent: 'North America', name: 'Guatemala' },
    { code: 'gg', continent: 'Europe', name: 'Guernsey' },
    { code: 'gn', continent: 'Africa', name: 'Guinea', nationality: 'Guinea' },
    { code: 'gw', continent: 'Africa', name: 'Guinea-Bissau', nationality: 'Guinea-Bissau' },
    { code: 'gy', continent: 'South America', name: 'Guyana' },
    { code: 'ht', continent: 'North America', name: 'Haiti' },
    { code: 'hn', continent: 'North America', name: 'Honduras', nationality: 'Honduras' },
    { code: 'hk', continent: 'Asia', name: 'Hong Kong' },
    { code: 'hu', continent: 'Europe', name: 'Hungría', nationality: 'Hungary' },
    { code: 'is', continent: 'Europe', name: 'Iceland', nationality: 'Iceland' },
    { code: 'in', continent: 'Asia', name: 'India' },
    { code: 'id', continent: 'Asia', name: 'Indonesia' },
    { code: 'ir', continent: 'Asia', name: 'Iran' },
    { code: 'iq', continent: 'Asia', name: 'Iraq' },
    { code: 'ie', continent: 'Europe', name: 'Ireland' },
    { code: 'im', continent: 'Europe', name: 'Isle of Man' },
    { code: 'il', continent: 'Asia', name: 'Israel', nationality: 'Israel' },
    { code: 'it', continent: 'Europe', name: 'Italia', nationality: 'Italy' },
    { code: 'jm', continent: 'North America', name: 'Jamaica' },
    { code: 'jp', continent: 'Asia', name: 'Japón', nationality: 'Japan' },
    { code: 'je', continent: 'Europe', name: 'Jersey' },
    { code: 'jo', continent: 'Asia', name: 'Jordania' },
    { code: 'kz', continent: 'Asia', name: 'Kazakhstan' },
    { code: 'ke', continent: 'Africa', name: 'Kenya' },
    { code: 'ki', continent: 'Oceania', name: 'Kiribati' },
    { code: 'xk', continent: 'Europe', name: 'Kosovo', nationality: 'Kosovo' },
    { code: 'kw', continent: 'Asia', name: 'Kuwait' },
    { code: 'kg', continent: 'Asia', name: 'Kyrgyzstan' },
    { code: 'la', continent: 'Asia', name: 'Laos' },
    { code: 'lv', continent: 'Europe', name: 'Latvia' },
    { code: 'lb', continent: 'Asia', name: 'Lebanon' },
    { code: 'ls', continent: 'Africa', name: 'Lesotho' },
    { code: 'lr', continent: 'Africa', name: 'Liberia' },
    { code: 'ly', continent: 'Africa', name: 'Libya' },
    { code: 'li', continent: 'Europe', name: 'Liechtenstein' },
    { code: 'lt', continent: 'Europe', name: 'Lithuania' },
    { code: 'lu', continent: 'Europe', name: 'Luxembourg' },
    { code: 'mo', continent: 'Asia', name: 'Macau' },
    { code: 'mg', continent: 'Africa', name: 'Madagascar' },
    { code: 'mw', continent: 'Africa', name: 'Malawi' },
    { code: 'my', continent: 'Asia', name: 'Malaysia' },
    { code: 'mv', continent: 'Asia', name: 'Maldives' },
    { code: 'ml', continent: 'Africa', name: 'Mali', nationality: 'Mali' },
    { code: 'mt', continent: 'Europe', name: 'Malta' },
    { code: 'mh', continent: 'Oceania', name: 'Islas Marshall' },
    { code: 'mq', continent: 'North America', name: 'Martinique' },
    { code: 'mr', continent: 'Africa', name: 'Mauritania', nationality: 'Mauritania' },
    { code: 'mu', continent: 'Africa', name: 'Mauritius' },
    { code: 'yt', continent: 'Africa', name: 'Mayotte' },
    { code: 'mx', continent: 'North America', name: 'México', nationality: 'Mexico' },
    { code: 'md', continent: 'Europe', name: 'Moldavia' },
    { code: 'mc', continent: 'Europe', name: 'Mónaco' },
    { code: 'mn', continent: 'Asia', name: 'Mongolia' },
    { code: 'me', continent: 'Europe', name: 'Montenegro', nationality: 'Montenegro' },
    { code: 'ms', continent: 'North America', name: 'Montserrat' },
    { code: 'ma', continent: 'Africa', name: 'Marruecos', nationality: 'Morocco' },
    { code: 'mz', continent: 'Africa', name: 'Mozambique', nationality: 'Mozambique' },
    { code: 'mm', continent: 'Asia', name: 'Myanmar' },
    { code: 'na', continent: 'Africa', name: 'Namibia' },
    { code: 'nr', continent: 'Oceania', name: 'Nauru' },
    { code: 'np', continent: 'Asia', name: 'Nepal' },
    { code: 'nl', continent: 'Europe', name: 'Países Bajos', nationality: 'Netherlands' },
    { code: 'nc', continent: 'Oceania', name: 'Nueva Caledonia' },
    { code: 'nz', continent: 'Oceania', name: 'Nueva Zelanda' },
    { code: 'ni', continent: 'North America', name: 'Nicaragua' },
    { code: 'ng', continent: 'Africa', name: 'Níger', nationality: 'Niger' },
    { code: 'ne', continent: 'Africa', name: 'Nigeria', nationality: 'Nigeria' },
    { code: 'nu', continent: 'Oceania', name: 'Niue' },
    { code: 'nf', continent: 'Oceania', name: 'Isla Norfolk' },
    { code: 'kp', continent: 'Asia', name: 'Corea del Norte' },
    { code: 'mk', continent: 'Europe', name: 'Macedonia del Norte', nationality: 'North Macedonia' },
    { code: 'gb-nir', continent: 'Europe', name: 'Northern Ireland' },
    { code: 'mp', continent: 'Oceania', name: 'Islas Marianas del Norte' },
    { code: 'no', continent: 'Europe', name: 'Noruega', nationality: 'Norway' },
    { code: 'om', continent: 'Asia', name: 'Omán' },
    { code: 'pc', name: 'Pacific Community' },
    { code: 'pk', continent: 'Asia', name: 'Pakistán' },
    { code: 'pa', continent: 'North America', name: 'Panamá' },
    { code: 'pg', continent: 'Oceania', name: 'Papúa Nueva Guinea' },
    { code: 'py', continent: 'South America', name: 'Paraguay', nationality: 'Paraguay' },
    { code: 'pe', continent: 'South America', name: 'Perú', nationality: 'Peru' },
    { code: 'ph', continent: 'Asia', name: 'Filipinas' },
    { code: 'pn', continent: 'Oceania', name: 'Islas Pitcairn' },
    { code: 'pl', continent: 'Europe', name: 'Polonia', nationality: 'Poland' },
    { code: 'pt', continent: 'Europe', name: 'Portugal', nationality: 'Portugal' },
    { code: 'pr', continent: 'North America', name: 'Puerto Rico' },
    { code: 'qa', continent: 'Asia', name: 'Qatar' },
    { code: 'cg', continent: 'Africa', name: 'República del Congo' },
    { code: 'ro', continent: 'Europe', name: 'Rumanía', nationality: 'Romania' },
    { code: 'ru', continent: 'Europe', name: 'Rusia', nationality: 'Russia' },
    { code: 'rw', continent: 'Africa', name: 'Ruanda' },
    { code: 'bl', continent: 'North America', name: 'Saint Barthélemy' },
    { code: 'sh-hl', continent: 'Africa', name: 'Santa Elena' },
    { code: 'kn', continent: 'North America', name: 'San Cristóbal y Nieves' },
    { code: 'lc', continent: 'North America', name: 'Santa Lucía' },
    { code: 'mf', continent: 'North America', name: 'San Martín' },
    { code: 'pm', continent: 'North America', name: 'San Pedro y Miquelón' },
    { code: 'vc', continent: 'North America', name: 'San Vicente y las Granadinas' },
    { code: 'ws', continent: 'Oceania', name: 'Samoa' },
    { code: 'sm', continent: 'Europe', name: 'San Marino' },
    { code: 'st', continent: 'Africa', name: 'Santo Tomé y Príncipe' },
    { code: 'sa', continent: 'Asia', name: 'Arabia Saudita' },
    { code: 'gb-sct', continent: 'Europe', name: 'Escocia', nationality: 'Scotland' },
    { code: 'sn', continent: 'Africa', name: 'Senegal', nationality: 'Senegal' },
    { code: 'rs', continent: 'Europe', name: 'Serbia', nationality: 'Serbia' },
    { code: 'sc', continent: 'Africa', name: 'Seychelles' },
    { code: 'sl', continent: 'Africa', name: 'Sierra Leona', nationality: 'Sierra Leone' },
    { code: 'sg', continent: 'Asia', name: 'Singapur' },
    { code: 'sx', continent: 'North America', name: 'Sint Maarten' },
    { code: 'sk', continent: 'Europe', name: 'Eslovaquia', nationality: 'Slovakia' },
    { code: 'si', continent: 'Europe', name: 'Eslovenia', nationality: 'Slovenia' },
    { code: 'sb', continent: 'Oceania', name: 'Islas Salomón' },
    { code: 'so', continent: 'Africa', name: 'Somalia' },
    { code: 'za', continent: 'Africa', name: 'Sudáfrica', nationality: 'South Africa' },
    { code: 'gs', continent: 'Antarctica', name: 'Georgia del Sur y las Islas Sandwich del Sur' },
    { code: 'kr', continent: 'Asia', name: 'Corea del Sur' },
    { code: 'ss', continent: 'Africa', name: 'Sudán del Sur' },
    { code: 'es', continent: 'Europe', name: 'España', nationality: 'Spain' },
    { code: 'lk', continent: 'Asia', name: 'Sri Lanka' },
    { code: 'ps', continent: 'Asia', name: 'Estado de Palestina' },
    { code: 'sd', continent: 'Africa', name: 'Sudán' },
    { code: 'sr', continent: 'South America', name: 'Surinam', nationality: 'Suriname' },
    { code: 'se', continent: 'Europe', name: 'Suecia', nationality: 'Sweden' },
    { code: 'ch', continent: 'Europe', name: 'Suiza', nationality: 'Switzerland' },
    { code: 'sy', continent: 'Asia', name: 'Siria', nationality: 'Syria' },
    { code: 'tw', continent: 'Asia', name: 'Taiwán' },
    { code: 'tj', continent: 'Asia', name: 'Tayikistán' },
    { code: 'tz', continent: 'Africa', name: 'Tanzania' },
    { code: 'th', continent: 'Asia', name: 'Tailandia' },
    { code: 'tl', continent: 'Asia', name: 'Timor-Leste' },
    { code: 'tg', continent: 'Africa', name: 'Togo', nationality: 'Togo' },
    { code: 'tk', continent: 'Oceania', name: 'Tokelau' },
    { code: 'to', continent: 'Oceania', name: 'Tonga' },
    { code: 'tt', continent: 'South America', name: 'Trinidad y Tobago' },
    { code: 'sh-ta', continent: 'Africa', name: 'Tristan da Cunha' },
    { code: 'tn', continent: 'Africa', name: 'Túnez', nationality: 'Tunisia' },
    { code: 'tm', continent: 'Asia', name: 'Turkmenistán' },
    { code: 'tc', continent: 'North America', name: 'Islas Turcas y Caicos' },
    { code: 'tv', continent: 'Oceania', name: 'Tuvalu' },
    { code: 'tr', continent: 'Asia', name: 'Turquía', nationality: 'Türkiye' },
    { code: 'ug', continent: 'Africa', name: 'Uganda' },
    { code: 'ua', continent: 'Europe', name: 'Ucrania', nationality: 'Ukraine' },
    { code: 'ae', continent: 'Asia', name: 'Emiratos Árabes Unidos' },
    { code: 'gb', continent: 'Europe', name: 'Reino Unido' },
    { code: 'us', continent: 'North America', name: 'Estados Unidos de América', nationality: 'USA' },
    { code: 'xx', name: 'Unknown' },
    { code: 'uy', continent: 'South America', name: 'Uruguay', nationality: 'Uruguay' },
    { code: 'uz', continent: 'Asia', name: 'Uzbekistán' },
    { code: 'vu', continent: 'Oceania', name: 'Vanuatu' },
    { code: 've', continent: 'South America', name: 'Venezuela', nationality: 'Venezuela' },
    { code: 'vn', continent: 'Asia', name: 'Vietnam' },
    { code: 'vg', continent: 'North America', name: 'Virgin Islands (British)' },
    { code: 'vi', continent: 'North America', name: 'Virgin Islands (U.S.)' },
    { code: 'gb-wls', continent: 'Europe', name: 'Wales' },
    { code: 'wf', continent: 'Oceania', name: 'Wallis y Futuna' },
    { code: 'eh', continent: 'Africa', name: 'Sáhara Occidental' },
    { code: 'ye', continent: 'Asia', name: 'Yemen' },
    { code: 'zm', continent: 'Africa', name: 'Zambia' },
    { code: 'zw', continent: 'Africa', name: 'Zimbabue' },
];

export const getCountryByNationality = (nationality) => {
    if (!nationality) return null;
    return countries.find((country) => country.nationality === nationality);
};

export const getCountryCodeByNationality = (nationality) => {
    const country = getCountryByNationality(nationality);
    return country?.code || null;
};

export const getCountryNameInSpanish = (nationality) => {
    if (!nationality) return nationality;
    const country = getCountryByNationality(nationality);
    return country?.name || nationality;
};
